const React = require("react");
const Layout = require("./src/components/layout").default;

// 広告を出さないパス（docs/meemie-site-plan.md §2.4）
const AD_FREE_PATHS = /^\/meemie(\/|$)/;

exports.wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Layout {...props}>{element}</Layout>;
};

// /meemie/ 配下に AdSense のローダーと広告枠が残らないようにする。
//
// 初回ロードの HTML には gatsby-config.js の exclude により注入されないが、
// Gatsby は SPA なので、広告のある他ページから遷移してくると読み込み済みの
// adsbygoogle.js が同じドキュメントに残る。/meemie/ へのリンクはすべて素の
// <a>（フルロード）にしてあるので通常は発生しないが、リンクの張り替えや
// 履歴操作で入ってきた場合の保険として DOM からも取り除く。
exports.onRouteUpdate = ({ location }) => {
  if (typeof document === "undefined") return;
  if (!AD_FREE_PATHS.test(location.pathname)) return;

  document
    .querySelectorAll(
      'script[src*="googlesyndication"], script[src*="pagead2"], ins.adsbygoogle',
    )
    .forEach((el) => el.remove());
};
